import {Construtor} from './construtor';

export class AgendaRoteiroPontoFisico implements Construtor<AgendaRoteiroPontoFisico> {

  public idAgendaRoteiroPontoFisico: number;
  public idRoteiroPontoFisico: number;
  public idRoteiro: number;
  public dataAgenda: Date;
  public nomePontoFisico: string;
  public idPontoFisico: number;
  public cor: string;
  public selecionado: boolean;
  public alterado: boolean;

  constructor(object?: any) {
    if (object !== undefined && object !== null) {

      if (object instanceof AgendaRoteiroPontoFisico) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }

    return this;
  }

  copyObject(roteiro: AgendaRoteiroPontoFisico): void {
    this.idAgendaRoteiroPontoFisico = roteiro.idAgendaRoteiroPontoFisico;
    this.idRoteiroPontoFisico = roteiro.idRoteiroPontoFisico;
    this.idRoteiro = roteiro.idRoteiro;
    this.dataAgenda = roteiro.dataAgenda;
    this.idPontoFisico = roteiro.idPontoFisico;
    this.nomePontoFisico = roteiro.nomePontoFisico;
  }

  parseFromJson(roteiro: any): void {
    this.idAgendaRoteiroPontoFisico = roteiro.idAgendaRoteiroPontoFisico;
    this.idRoteiroPontoFisico = roteiro.idRoteiroPontoFisico;
    this.idRoteiro = roteiro.idRoteiro;
    this.dataAgenda = roteiro.dataAgenda;
    this.idPontoFisico = roteiro.idPontoFisico;
    this.nomePontoFisico = roteiro.nomePontoFisico;
  }

  modeloCompleto(): boolean {
    return this.idRoteiroPontoFisico !== undefined;
  }

  getNewInstance(object?: any): AgendaRoteiroPontoFisico {
    return new AgendaRoteiroPontoFisico(object);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/agenda-roteiro-ponto-fisico.ts